import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage, IMAGE_FIT } from 'shared/UI/SmartImage'
import { DummyAnchorTag } from 'LiveBoard/components/shared/DummyAnchorTag'

import './style.css.scss'

const ItemPreview = (props) => (
  <div className={`item-preview-container ${props.className}`}>
    <div className="item-preview-content">
      <SmartImage className="preview-img" config={{url: props.item.image.url, fit: IMAGE_FIT.contain}} />
      <span className="preview-text">
        <span>
          <DummyAnchorTag url={props.item.itemUrl}>{props.item.name}</DummyAnchorTag>
        </span>
      </span>
    </div>
  </div>
)

ItemPreview.propTypes = {
  className: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired
}

export default ItemPreview
